<mat-card *ngIf="card; else page">
    <ng-container *ngTemplateOutlet="page"></ng-container>
</mat-card>

<ng-template #page>
    <div *ngIf="showHeader" class="header">
        <div class="text-center">
            <img [alt]="companyName + ' Logo'" [src]="companyImg" class="w-25 mx-auto logoBg">
        </div>
        <div *ngIf="!community?.profile_survey_intro_text_rendered" class="text-center">
            <h3>Please update your profile</h3>
        </div>
    </div>
    <div *ngIf="community" class="content">
        <div *ngIf="community.profile_survey_intro_text_rendered" class="d-flex w-100">
            <div [innerHTML]="community.profile_survey_intro_text_rendered">
            </div>
        </div>
        <form [formGroup]="profileForm" class="mt-10 flex-col mb-10">
            <ng-container *ngFor="let field of this.dynamicFormFields">
                <ng-container *ngIf="field.question_type">
                    <ng-container
                            *ngIf="((!field.parent_question && !field.parent_option) || !field.hidden) && field.question_type">
                        <div class="flex-col mt-5">
                            <p *ngIf="!field.text_rendered" class="labelTitle">{{ field.text }}</p>
                            <p *ngIf="!field.help_text_rendered" class="labelSubtitle">{{ field.help_text }}</p>
                            <div *ngIf="field.text_rendered" [innerHTML]="field.text_rendered"
                                 class="ck-editorControl"></div>
                            <div *ngIf="field.help_text_rendered" [innerHTML]="field.help_text_rendered"
                                 class="ck-editorControl"></div>

                            <div *ngIf="field.image">
                                <img [src]="field.image" class="max-w-100">
                            </div>
                            <ng-container *ngIf="field.question_type === 'multiple_choice'">
                                <div class="flex-col gap-15">
                                    <div *ngFor="let option of field.options; let i=index"
                                         class="flex-row align-items-center gap-15">

                                        <button (click)="fieldSelect(field, option)"
                                                [color]="this.profileForm.get(field.id.toString())?.value?.includes(option.id)? 'primary' :null"
                                                class="customFab"
                                                mat-mini-fab>
                                            <mat-icon
                                                    *ngIf="this.profileForm.get(field.id.toString())?.value?.includes(option.id)">
                                                check
                                            </mat-icon>
                                        </button>
                                        {{ option.text }}
                                    </div>
                                </div>
                                <small *ngIf="profileForm.controls[field.id].hasError('required')" class="errorMsg">
                                    This field is required
                                </small>
                            </ng-container>
                            <ng-container *ngIf=" field.question_type === 'single_choice'">
                                <mat-radio-group [formControlName]="field.id"
                                                 class="flex-col">
                                    <mat-radio-button *ngFor="let option of field.options" [value]="option.id"
                                                      class="example-radio-button">{{ option.text }}
                                    </mat-radio-button>
                                </mat-radio-group>
                                <small *ngIf="profileForm.controls[field.id].hasError('required')" class="errorMsg">
                                    This field is required
                                </small>
                            </ng-container>

                            <ng-container
                                    *ngIf="field.question_type !== 'date' &&  field.question_type !== 'single_choice' && field.question_type !== 'multiple_choice'">
                                <mat-form-field [class.noBottomPadding]="getControl(field.id)?.valid"
                                                appearance="outline" class="w-100"
                                                color="accent">
                                    <mat-label></mat-label>
                                    <ng-container
                                            *ngIf="field.question_type == 'dropdown'">
                                        <mat-select [formControlName]="field.id"
                                                    [multiple]="field.dropdown_allows_multiple_selection">
                                            <mat-option
                                                    (onSelectionChange)="field.dropdown_allows_multiple_selection? fieldSelect(field, $event ): null"
                                                    *ngFor="let option of field.options"
                                                    [value]="option.id">{{ option.text }}
                                            </mat-option>
                                        </mat-select>
                                    </ng-container>
                                    <ng-container *ngIf="field.question_type == 'text'">
                                        <input [formControlName]="field.id" matInput type="text">
                                    </ng-container>
                                    <ng-container *ngIf="field.question_type == 'numeric'">
                                        <input [formControlName]="field.id" matInput type="number">
                                    </ng-container>
                                    <mat-error *ngIf="profileForm.controls[field.id].hasError('required')">
                                        This field is required
                                    </mat-error>
                                </mat-form-field>
                            </ng-container>
                            <ng-container *ngIf="field.question_type === 'date'">
                                <mat-form-field [class.noBottomPadding]="getControl(field.id)?.valid"
                                                appearance="outline"
                                                class="w-100">
                                    <mat-label></mat-label>
                                    <input #dateInput (dateChange)="checkIfCorrectAge(field, $event.value)"
                                           [formControlName]="field.id" [matDatepicker]="picker"
                                           [max]="field.is_dob? today : null"
                                           matInput>
                                    <mat-datepicker-toggle [for]="picker" matIconSuffix></mat-datepicker-toggle>
                                    <mat-datepicker #picker></mat-datepicker>
                                    <mat-error *ngIf="profileForm.controls[field.id].hasError('required')">
                                        This field is required
                                    </mat-error>
                                </mat-form-field>
                                <small *ngIf="field.incorrectAge && dateInput.value" class="errorMsg">
                                    Minimum years {{ field.minimum_number_of_years }}
                                </small>
                            </ng-container>
                        </div>
                    </ng-container>
                </ng-container>
                <ng-container *ngIf="!field.question_type">
                    <div class="flex-col mt-5">
                        <p *ngIf="!field.text_rendered" class="labelTitle">{{ field.text }}</p>
                        <div *ngIf="field.text_rendered" [innerHTML]="field.text_rendered"
                             class="ck-editorControl"></div>
                    </div>
                </ng-container>
            </ng-container>
        </form>
        <div class="w-100 text-center mt-20">
            <button (click)="submit()" *ngIf="isRegistrationPage"
                    [disabled]="loading || profileForm.invalid || !allAgesCorrect()"
                    class="mx-auto"
                    color="accent" mat-flat-button>
                Next
                <mat-icon *ngIf="loading">
                    <mat-spinner color="accent"></mat-spinner>
                </mat-icon>
            </button>
            <button (click)="update()" *ngIf="!isRegistrationPage"
                    [disabled]="loading || profileForm.invalid|| !allAgesCorrect()"
                    class="mx-auto"
                    color="primary" mat-raised-button>
                Update Profile
                <mat-icon *ngIf="loading">
                    <mat-spinner color="accent"></mat-spinner>
                </mat-icon>
            </button>
        </div>
    </div>

</ng-template>
